import { useCallback, useMemo, useState } from 'react';

import { KebabMenu } from 'ui';

import { useTableContext } from '../../../table.context';
import { TableCSVExport } from './TableCSVExport';
import { TablePDF } from './TablePdf';

const TableExport = () => {
  const [isFeatureLoading, setIsFeatureLoading] = useState({
    csv: false,
    pdfSave: false,
    pdfPrint: false,
  });

  const ctx = useTableContext();
  const exportQuery = ctx.exportOptions?.query;
  const exportColumns = ctx.exportOptions?.columns;

  const pdfOptions = useMemo(() => {
    const pdfOptions = ctx.pdfOptions;
    return pdfOptions;
  }, [ctx.pdfOptions]);

  const hasMultipleExportOptions = useMemo(
    () => exportQuery && exportColumns && pdfOptions,
    [exportColumns, exportQuery, pdfOptions]
  );

  const isLoading = useMemo(
    () => Object.values(isFeatureLoading).some((value) => value),
    [isFeatureLoading]
  );

  const handleLoading = useCallback((type: keyof typeof isFeatureLoading, loading: boolean) => {
    setIsFeatureLoading((prev) => ({ ...prev, [type]: loading }));
  }, []);

  if (hasMultipleExportOptions && !!exportQuery) {
    return (
      <KebabMenu
        keepMounted
        buttonProps={{
          variant: 'outline',
          size: 'md',
        }}
        loading={isLoading}
      >
        <TableCSVExport
          type="menu-link"
          setIsLoading={(loading) => handleLoading('csv', loading)}
        />
        <TablePDF type="save" setIsLoading={(loading) => handleLoading('pdfSave', loading)} />
        <TablePDF type="print" setIsLoading={(loading) => handleLoading('pdfPrint', loading)} />
      </KebabMenu>
    );
  }

  return <TableCSVExport type={'button'} />;
};

export { TableExport };
